import * as Sentry from '@sentry/react';
import type React from 'react';
import { useEffect } from 'react';

import { useConfig } from '@/core/providers/ConfigProvider';

/**
 * Minimal, dependency-free Sentry init so client-side errors are actually reported -
 * including failed case-request submits on the unauthenticated end-client pages.
 *
 * Intentionally does NOT use Clerk (useUser) or AppEnv: those providers are not mounted
 * on the public case-request flow, which is exactly why the full SentryInitialization
 * cannot run there. User/instance enrichment can be layered on inside the authenticated
 * area later (via Sentry.setUser), on top of this base init.
 */
export const SentryClientInit: React.FC = () => {
	const config = useConfig();

	useEffect(() => {
		const dsn = config.sentry?.dsn;
		if (!dsn) {
			return;
		}

		Sentry.init({
			dsn,
			environment: import.meta.env.MODE,
			release: import.meta.env.VITE_APP_VERSION,
			enabled: true,
		});
	}, [config.sentry?.dsn]);

	return null;
};
